import React, { useEffect } from 'react';
import './disclosureViewer.css';

/** Native browser PDF display via presigned S3 URL (no JS PDF library). */
export default function DisclosureViewerModal({ open, title, pdfUrl, loading, error, onClose }) {
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="disclosure-viewer-title"
      onClick={onClose}
    >
      <div
        className="flex max-h-[92vh] w-full max-w-5xl flex-col rounded-2xl bg-white shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex shrink-0 items-center justify-between gap-3 border-b px-5 py-4">
          <h2 id="disclosure-viewer-title" className="text-lg font-semibold text-gray-900">
            {title}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100"
          >
            Close
          </button>
        </div>

        <div className="min-h-[200px] flex-1 overflow-hidden">
          {loading && <p className="px-5 py-4 text-sm text-gray-600">Loading document...</p>}
          {error && (
            <p className="mx-5 my-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800">
              {error}
            </p>
          )}
          {!loading && !error && pdfUrl && (
            <div className="disclosure-pdf-viewer p-3">
              <embed src={pdfUrl} type="application/pdf" title={title} className="disclosure-pdf-embed" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
